<template>
  <b-row class="mt-5">
    <b-col cols="12">
      <div class="bigger">
        <div class="mb-12">
          <b-btn pill size="lg" style="background-color: burlywood;margin:5%">
            <router-link class="text-decoration-none font-weight-bold text-white" :to="{name:'Home'}">
              زندگی هوشمند

            </router-link>
          </b-btn>

        </div>
        <div class="smaller">
          <p class="font-weight-bold h4 m-5 text-dark">منتشر شده در 9 روز پیش</p>
          <p class="font-weight-bold h3 m-5">اقدامات اولیه برای زمانی که گوشیتان خیس شده است</p>
        </div>
      </div>

    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "Card"
}
</script>

<style scoped>
.bigger{
  width:100%;
  height:500px;
  background-image:url('../assets/logo.png');
  background-size:cover;
  background-position:center;
  position:relative;
  border-radius: 20px;
}
.smaller{
  width:100%;
  background-color:rgba(0, 16, 255,0.36);
  backdrop-filter: blur(10px);
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  position:absolute;
  bottom:0;
  text-align:right;
  color:white;
}
</style>